import React from "react";
import ReactDOM from "react-dom/client";
import reportWebVitals from "./reportWebVitals";
import "./Styles/main.scss";
import Game from "./Components/Game";
import {
  Routes,
  BrowserRouter as Router,
  Route,
  Navigate,
} from "react-router-dom";
import Result from "./Components/Result";
import { ResultStatus } from "./utils/types";
import FruitTypes from "./Components/FruitsTypes";
import Intro from "./Components/Intro";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <>
    <Router>
      <Routes>
        <Route path="/" element={<Intro />}></Route>
        <Route path="/game" element={<Game />}></Route>
        <Route path="/types" element={<FruitTypes />}></Route>
        <Route path="/result/win" element={<Result status={ResultStatus.Win} />}></Route>
        <Route path="/result/lose" element={<Result status={ResultStatus.Lose} />}></Route>
        <Route path="*" element={<Navigate to={"/"} />} />
      </Routes>
    </Router>
  </>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
